import React,{ useRef } from "react";
import "./Contact.css";
import { MdOutlineEmail } from "react-icons/md";
import data from "./data";

import emailjs from '@emailjs/browser';

const Contact = () => {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_rpzxjdh', 'template_uir2nif', form.current, 'ITb7FL6uKhUbnKYk-')
      .then((result) => {
        console.log(result.text);
      }, (error) => {
        console.log(error.text);
      });

      e.target.reset();
    }

    return (
      <section id="contact">
        <h5>Get In Touch</h5>
        <h2>Contact Me</h2>
        <div className="container contact_container">
          <div className="contact_options">
            <article className="contact_option">
              <MdOutlineEmail className="contact_option-icon" />
              <h4>Email</h4>
              <h6>beingashmit@gmail.com</h6>
              <a href="mailto:beingashmit@gmail.com" target="_blank" rel="noreferrer">
                Send a message
              </a>
            </article>
            <article className="contact_option">
              <MdOutlineEmail className="contact_option-icon" />
              <h4>Contact</h4>
              <h6>+91 6393078913</h6>
            
            </article>
            <div className="header_social">
      {
        data.map(item=> <a key={item.id} href={item.link} target="_blank"
        rel="noopener noreferrer">{item.icon}</a>)
      }

    </div>
       
          
          </div>
         
          <form ref={form} onSubmit={sendEmail}>
            <input
              type="text"
              name="name"
              placeholder="Your Full Name"
              required
            />
            <input type="email" name="email" placeholder="Your Email" required />
            <textarea
              name="message"
              rows="7"
              placeholder="Your Message"
              required
            ></textarea>
            <button type="submit" className="btn btn-primary">
              Send Message
            </button>
          </form>
        </div>
      </section>
    );
  };

  export default Contact;